import ExhaustivePaginatedFetcher from '../util/ExhaustivePaginatedFetcher';
import { addFeatures } from '../actions/features';
import { loadedApiFeatures } from '../actions/ui';
export var getFeatures = function getFeatures() {
  var url = '/api/features';
  return function (dispatch, getState) {
    var fetcher = new ExhaustivePaginatedFetcher();
    var addFeaturesToStore = function addFeaturesToStore(featuresList) {
      dispatch(addFeatures(featuresList));
    };
    return fetcher.get(url).then(addFeaturesToStore).then(function () {
      return dispatch(loadedApiFeatures(true));
    });
  };
};